import { InjectedConnector } from '@web3-react/injected-connector';

const SUPPORTEDCHAINIDS = [1, 43113];

export const injected = new InjectedConnector({
  supportedChainIds: SUPPORTEDCHAINIDS,
});
